import { render, staticRenderFns } from "./handhome4.vue?vue&type=template&id=5d849232&scoped=true"
import script from "./handhome4.vue?vue&type=script&lang=js"
export * from "./handhome4.vue?vue&type=script&lang=js"
import style0 from "./handhome4.vue?vue&type=style&index=0&id=5d849232&prod&lang=scss&scoped=true"
import style1 from "./handhome4.vue?vue&type=style&index=1&id=5d849232&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d849232",
  null
  
)

export default component.exports